// extracted by mini-css-extract-plugin
export default {"inputGroup":"search-input_inputGroup__3YTGB","searchIcon":"search-input_searchIcon__2HmaI","searchBtn":"search-input_searchBtn__7d3Ky","clear":"search-input_clear__ubi8p"};